// @ts-nocheck
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
  } from "@/components/ui/carousel"

  import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardTitle,
  } from "@/components/ui/card"



export default function ProfileMain () {
    return(
        <>
            
            <div className="flex flex-col items-center">
                <FeaturedItems />
                
                <h3 className="text-background text-3xl font-semibold mb-4">Recent</h3>
                <Activity />
            </div>
        </>
    )
    
    
}


interface FeaturedListProps {
    title: string,
    images: string[],
}

function FeaturedList({title="Peak", images=["https://i.scdn.co/image/ab67616d0000b273a12c5353b3d0385c6ce8c103",
    "https://i.scdn.co/image/ab67616d0000b273712701c5e263efc8726b1464","https://i.scdn.co/image/ab67616d0000b273bc200956ba9de7303d8bd068",
    "https://i.scdn.co/image/ab67616d0000b273a4c35326f6fe6676c10e31ac","https://i.scdn.co/image/ab67616d0000b2736c3fb85147fcf2972923cf2d"]}:FeaturedListProps){
    
    return(
        <>
        <div className="flex flex-col justify-center items mt-5 gap-2">
            <h2 className="text-secondary text-xl font-bold">{title}</h2>
            <Carousel
                opts={{
                    
                }}
                className="flex justify-center items-center w-75 sm:w-100 md:w-140 lg:w-200"
                >
                <CarouselContent>
                    {images.map((item, index) => (
                    <CarouselItem key={index} className="basis-1/2 md:basis-1/3 ">
                        <img className="h-35 lg:h-60" src={item} />
                    </CarouselItem>
                    ))}
                </CarouselContent>
                <CarouselPrevious className="bg-foreground text-secondary" />
                <CarouselNext className="bg-foreground text-secondary"/>
                </Carousel>
            </div>

        </>
    )
}

interface FeaturedItemsProps {
    title: string,
    type: string,
    desc: string,
    items: {}[];
}


function FeaturedItems(){
    return(
    <div className="flex flex-col md:flex-row items-center gap-4 mb-20">
        <Card className="flex justify-center items-center bg-foreground text-secondary mt-10 max-w-100 ease-in-out duration-200 hover:bg-primary hover:cursor-pointer">
            <CardContent>
                <img className="h-80"
                src="https://i.scdn.co/image/ab67616d0000b273a12c5353b3d0385c6ce8c103"/>
            </CardContent>
            <CardFooter className="flex flex-col justify-center items-center">
                <CardTitle className="flex text-lg items-center justify-center text-center break-after-auto">Albums that're better than sex</CardTitle>
                <CardDescription>I promise I've had sex</CardDescription>
                
            </CardFooter>
         </Card>

         <Card className="flex justify-center h-fit items-center bg-foreground text-secondary mt-10 max-w-50 ease-in-out duration-200 hover:bg-primary hover:cursor-pointer">
            <CardContent>
                <img className="w-40"
                src="http://image.tmdb.org/t/p/w500//vR7hwaGQ0ySRoq1WobiNRaPs4WO.jpg"/>
            </CardContent>
            <CardFooter className="flex flex-col justify-center items-center">
                <CardTitle className="flex text-md items-center justify-center text-center break-after-auto">Peak weeb shit</CardTitle>
                <CardDescription className="text-center">Watch any of these and it'll put you on. i stg</CardDescription>
                

            </CardFooter>
         </Card>

         <Card className="flex justify-center h-fit items-center bg-foreground text-secondary mt-10 max-w-50 md:order-first ease-in-out duration-200 hover:bg-primary hover:cursor-pointer">
            <CardContent>
                <img className="w-40"
                src="http://image.tmdb.org/t/p/w500//g5IoYeudx9XBEfwNL0fHvSckLBz.jpg"/>
            </CardContent>
            <CardFooter className="flex flex-col justify-center items-center">
                <CardTitle className="flex text-md items-center justify-center text-center break-after-auto">I only watch good movies</CardTitle>
                <CardDescription>I love edgar wright</CardDescription>
                
            </CardFooter>
         </Card>
    </div>
    )
    
}

function Activity(){
    return(
        <div className="flex flex-col gap-4 mb-10">
            <ActivityItem time="1h"/>
            <ActivityItem time="4h"/>
            <ActivityItem type="list" contentName="movies with good food" time="7h"/>
            <ActivityItem type="list" contentName="movies with good food" time="13h"/>
            <ActivityItem type="later" contentName="Good Burger" time="yesterday"/>
            <ActivityItem contentName="happy tapioca" time="03/26"/>
            
            
            <ActivityItem type="later" contentName="Good Burger" time="yesterday"/>
            <ActivityItem contentName="happy tapioca" time="03/26"/>

        </div>
    )
}


interface ActivityItemProps {
    type: "like"|"later"|"list",
    user: string,
    contentName: string,
    time: string,

}

function ActivityItem({type="like",user="mat",contentName="fartmovie",time="02/05"}:ActivityItemProps){
    let isLike = false;
    let isList = false;
    let isLater = false;


    switch(type){
        case "like":
            isLike = true;
            break;
        case "later":
            isLater = true;
            break;
        case "list":
            isList = true;
            break;
        default:
            return;
    }
    

    return(
        <article className=" flex w-150 h-15 rounded-xl bg-primary text-muted-foreground items-center justify-center text-lg hover:bg-neutral-800 ease-in-out duration-200">
            {
                isLike && <p><span className="text-accent font-semibold">{user}</span> liked <span className="text-accent font-semibold">{contentName}</span> - {time}</p> 
            }

            {
                isList && <p><span className="text-accent font-semibold">{user}</span> created a new list <span className="text-accent font-semibold">{contentName}</span> - {time}</p>
            }

            {
                isLater && <p><span className="text-accent font-semibold">{user}</span> added <span className="text-accent font-semibold">{contentName}</span> to their consume later - {time}</p>
            }
            
            
        </article>
    )
}